import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../context/MyContext';

function InactivityHandler({ children }) {
  const { isAuthenticated, logout } = useMyContext();
  const navigate = useNavigate();

  const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 60 minutes in milliseconds

  const checkInactivity = () => {
    const lastActivityTimestamp = localStorage.getItem('lastActivityTimestamp');
    if (lastActivityTimestamp) {
      const currentTime = Date.now();
      if (currentTime - parseInt(lastActivityTimestamp) > INACTIVITY_TIMEOUT) {
        // console.log('User inactive for 1 Hour. Logging out.');
        logout();
        navigate("/");
      }
    }
  };

  const updateActivityTimestamp = () => {
    localStorage.setItem('lastActivityTimestamp', Date.now().toString());
  };

  useEffect(() => {
    if (isAuthenticated) {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
      events.forEach(event => {
        document.addEventListener(event, updateActivityTimestamp);
      });

      const intervalId = setInterval(checkInactivity, 60000); // Check every minute

      // Initial check
      checkInactivity();

      return () => {
        events.forEach(event => {
          document.removeEventListener(event, updateActivityTimestamp);
        });
        clearInterval(intervalId);
      };
    }
  }, [isAuthenticated, logout, navigate]);

  return children;
}

export default InactivityHandler;